import { type RefObject } from 'react';
import { Trans, useTranslation } from 'next-i18next/pages';
import { Checkbox } from '@pkgs/components/components/Checkbox/Checkbox';
import { type Listing } from '@pkgs/api';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useExposeTracking } from '@/hooks/useExposeTracking';
import { ExpandableLabel } from '@/components/property-expose/ExpandableLabel/ExpandableLabel';

import styles from '../ContactForm.module.css';

export const PrivateOfficeConsent = ({
  privateOfficeConsentRef,
  listing,
}: {
  privateOfficeConsentRef: RefObject<HTMLDivElement>;
  listing: Listing;
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { trackExposeUserInteractionEvent } = useExposeTracking();

  return (
    <Checkbox
      className={styles.checkbox}
      name="privateOfficeConsent"
      aria-label={t('search.contact.form.label.poConsent.checkboxLabel')}
      size="m"
      onChange={() => trackExposeUserInteractionEvent({ elementId: 'request-expose_consent_checkbox-private-office' })}
      label={
        <>
          <ExpandableLabel
            className={styles.expandableMarketingConsent}
            maxLines={3}
            data-testid="expose-contact-form_po-consent_expandable-label"
          >
            <div ref={privateOfficeConsentRef}>
              <Trans
                i18nKey="search.contact.form.label.poConsent"
                t={t}
                values={{ legalEntity: listing.poConsent?.legalEntity }}
                components={[
                  <a key="imprint-url" href={listing.poConsent?.imprintUrl} target="_blank" rel="noreferrer" />,
                  <a key="data-privacy-url" href={listing.poConsent?.dataPrivacyUrl} target="_blank" rel="noreferrer" />,
                ]}
              />
            </div>
          </ExpandableLabel>
        </>
      }
    />
  );
};
